export default __webpack_public_path__ + "static/media/cryp.1548aced.png";